let fetcherInstance = null;
export function initializeFetcher(instance) {
    fetcherInstance = instance;
}
export function fetcher() {
    if (!fetcherInstance) {
        throw new Error('You are trying to fetch profile data before the fetch instance has been intialized.');
    }
    return fetcherInstance;
}
